import { AICIcon, HPBIcon, MOHIcon, NHGIcon, NUHSIcon, SingHealthIcon } from '@shared/assets';
import { SITE_CORE_URL } from '@shared/constants/paths';

export const ABOUT_LIST = [
  {
    title: 'About HealthHub',
    url: SITE_CORE_URL.aboutUs,
  },
  {
    title: 'Privacy Policy',
    url: SITE_CORE_URL.privacyPolicy,
  },
  {
    title: 'Terms of Use',
    url: SITE_CORE_URL.termsOfUse,
  },
  {
    title: 'Contact Us',
    url: SITE_CORE_URL.contactUs,
  },
];

export const PARTNERSHIP_LIST = [
  {
    alt: 'National Healthcare Group',
    icon: NHGIcon,
    url: 'https://corp.nhg.com.sg/Pages/default.aspx',
  },
  {
    alt: 'National University Health System',
    icon: NUHSIcon,
    url: 'https://www.nuhs.edu.sg',
  },
  {
    alt: 'SingHealth',
    icon: SingHealthIcon,
    url: 'https://www.singhealth.com.sg',
  },
  {
    alt: 'Ministry of Health',
    icon: MOHIcon,
    url: 'https://www.moh.gov.sg',
  },
  {
    alt: 'Health Promotion Board',
    icon: HPBIcon,
    url: 'https://www.hpb.gov.sg',
  },
  {
    alt: 'Agency of Integrated Care',
    icon: AICIcon,
    url: 'https://www.aic.sg',
  },
];
